"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://dyn.invisionapp.com/share/KMNP30LF35Z#/screens/324754218_08_Label_Definition
 */
var React = require("react");
/**
 * OUI tag component.
 *
 * @oui-component Tag
 */
var Tag = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#5a5d60" : _b, children = _a.children, testId = _a.testId, rest = __rest(_a, ["color", "children", "testId"]);
    return (React.createElement("span", __assign({ className: "oui-tag", "data-test-id": testId, style: { backgroundColor: color } }, rest), children));
};
exports.default = Tag;
//# sourceMappingURL=Tag.js.map